<template>
  <div @click="onClick" :id="ques.index" class="question" :class="{'analysis':hasAnalysis}">
    <div class="icon-result icon-right" v-if="ques.is_right==1&&hasCorrectTag&&ques.ques_type!=5">
      <i class="ivu-icon ivu-icon-md-checkmark"></i>
    </div>
    <div
      class="icon-result icon-error"
      v-else-if="ques.is_right!=1&&hasCorrectTag&&ques.ques_type!=5"
    >
      <i class="ivu-icon ivu-icon-md-close"></i>
    </div>
    <div class="stem bold" :class="'stem'+ques.ques_type.toString()">
      <div class="num-type">
        <span>{{index}}.(</span>
        <span class="type">{{ques.ques_type_name+' '+ques.score+' 分'}}</span>)
      </div>
      <div class="rich-text" v-if="ques.ques_type!=5" v-html="ques.ques_stem"></div>
    </div>
    <div class="rich-text stem5" v-if="ques.ques_type==5" v-html="ques.ques_stem"></div>
    <div class="options">
      <RadioGroup
        v-model="ques.right_answer"
        v-if="ques.ques_type==1||ques.ques_type==3"
        @change="onChange(ques)"
        :disabled="readonly"
      >
        <Radio :label="option.id" v-for="(option,index) in ques.ques_option" :key="option.id">
          <div class="option">
            <span>{{chars[index+1]}}、</span>
            <div class="rich-text">
              <div v-html="option.content"></div>
              <div style="clear:both;"></div>
            </div>
          </div>
        </Radio>
      </RadioGroup>
      <CheckboxGroup
        v-model="ques.right_answer"
        v-else-if="ques.ques_type==2"
        @change="onChange(ques)"
        :disabled="readonly"
      >
        <Checkbox v-for="(option,index) in ques.ques_option" :label="option.id" :key="option.id">
          <div class="option">
            <span>{{chars[index+1]}}、</span>
            <div class="rich-text">
              <div v-html="option.content"></div>
              <div style="clear:both;"></div>
            </div>
          </div>
        </Checkbox>
      </CheckboxGroup>
      <div class="line" v-else-if="ques.ques_type==4">
        <div>
          <div class="line-title">题目</div>
          <div
            class="option"
            v-for="(leftOption,index) in ques.ques_option.left"
            :key="leftOption.id"
          >
            <div class="stem">
              <span>{{index+1}})</span>
              <span v-html="leftOption.content"></span>
            </div>
            <div class="answer">
              <span>答案</span>
              <RadioGroup v-model="ques.right_answer[leftOption.id]" :disabled="readonly">
                <Radio
                  :label="rightOption.id"
                  v-for="rightOption in ques.ques_option.right"
                  :key="rightOption.id"
                  @change="onChange(ques)"
                >{{chars[rightOption.id]}}</Radio>
              </RadioGroup>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="line-title">选项</div>
          <div class="option" v-for="rightOption in ques.ques_option.right" :key="rightOption.id">
            <div class="num">选项{{chars[rightOption.id]}}</div>
            <div v-html="rightOption.content"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="analysis clear" :class="'analysis'+ques.ques_type.toString()" v-if="hasAnalysis">
      <div>
        <a class="collapse" v-if="showCollapse" @click="expandAnalysis=!expandAnalysis">
          {{expandAnalysis?'收起':'展开'}}答案解析
          <i class="ivu-icon ivu-icon-md-arrow-dropdown" v-if="!expandAnalysis"></i>
          <i class="ivu-icon ivu-icon-md-arrow-dropup" v-else></i>
        </a>
      </div>
      <div v-if="!showCollapse||expandAnalysis">
        <div class="answer clear" v-if="ques.ques_type!=5">
          <div class="f-left">
            <span>
              <span>正确答案：</span>
              <span class="primary-color">{{ques.answer}}</span>
            </span>
            <span class="user" v-if="ques.user_answer">
              <span>您的答案：</span>
              <span class="primary-color">{{ques.user_answer_label}}</span>
            </span>
          </div>
        </div>
        <div class="subjective-answer" v-else-if="ques.ques_type==5&&readonly&&ques.user_answer">
          <div>您的答案：</div>
          <div v-if="ques.user_answer.length>0" v-html="ques.user_answer_label[0]['id']"></div>
        </div>
        <div class="detail">
          <div>
            <label>考&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;点：</label>
            <span class="point" v-for="(p,index) in points" :key="index">{{p}}</span>
            <span v-if="points.length==0">暂无考点</span>
          </div>
          <div class="analysis-detail">
            <label>题目解析：</label>
            <div v-html="ques.ques_analysis" v-if="ques.ques_analysis"></div>
            <div v-else>暂无解析</div>
          </div>
        </div>
      </div>
    </div>
    <ImageViewer :isShow.sync="showImageViewer" :images="images"></ImageViewer>
  </div>
</template>
<script>
import ImageViewer from "@/components/ImageViewer.vue";
import { HomeworkQuestionType } from "@/utils/enums";

export default {
  name: "HomeworkPreviewQuestion",
  mounted () {
    this.mathJax()
  },
  components: { ImageViewer },
  props: {
    ques: {
      type: Object
    },
    index: {
      type: Number
    },
    readonly: {
      type: Boolean,
      default: false
    },
    hasAnalysis: {
      type: Boolean,
      default: false
    },
    showOperate: {
      type: Boolean,
      default: false
    },
    hasCorrectTag: {
      type: Boolean,
      default: false
    },
    showCollapse: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      chars: { 1: "A", 2: "B", 3: "C", 4: "D", 5: "E", 6: "F" },
      points: [],
      showCorrection: false,
      correction: {
        type: "",
        error_msg: ""
      },
      images: [],
      showImageViewer: false,
      expandAnalysis: false
    };
  },
  created() {
    let ques = this.ques;
    ques.ques_type_name = HomeworkQuestionType.getValue(ques.ques_type);

    let right_answer;
    if (ques.ques_type == 1 || ques.ques_type == 3) {
      right_answer = ques.ques_option.filter(o => o.is_right == "1")[0].id;
      ques.answer = this.chars[right_answer];
    } else if (ques.ques_type == 2) {
      right_answer = [];
      let answer = [];
      ques.ques_option
        .filter(o => o.is_right == "1")
        .forEach(o => {
          right_answer.push(o.id);
          answer.push(this.chars[o.id]);
        });
      ques.answer = answer.join(" ");
    } else if (ques.ques_type == 4) {
      right_answer = {};
      let answer = [];
      ques.ques_option.left.forEach(o => {
        right_answer[o.id] = o.is_right;
        answer.push(o.id + ")" + this.chars[o.is_right]);
      });
      ques.answer = answer.join(" ");
    }
    ques.right_answer = right_answer;

    if (ques.user_answer) {
      let user_answer;
      if (typeof ques.user_answer === "string") {
        user_answer = JSON.parse(ques.user_answer);
      } else {
        user_answer = ques.user_answer;
      }
      if (ques.ques_type != 5) {
        let answers = [];
        user_answer.forEach(a => {
          if (ques.ques_type == 4) {
            if (a.answer) {
              answers.push(a.id + ")" + this.chars[a.answer] + " ");
            }
          } else {
            if (a.id) {
              answers.push(this.chars[a.id]);
            }
          }
        });
        ques.user_answer_label = answers.join("");
      } else {
        ques.user_answer_label = user_answer;
      }
    }

    let point = this.ques.point_name || this.ques.point;
    let points;
    if (point) {
      points = point.split(",");
    } else {
      points = [];
    }
    this.points = points;
  },
  watch: {
    answer: {
      deep: true,
      handler: function() {
        this.onChange(this.ques);
      }
    }
  },
  methods: {
    mathJax() {
      let _this = this;
      if (this.MathJax.isMathjaxConfig) { // 判断是否初始配置，若无则配置。
          this.MathJax.initMathjaxConfig()
      }
      setTimeout(function(){
        _this.MathJax.MathQueue()// 传入组件id，让组件被MathJax渲染
      },2000)
    },
    onChange(ques) {
      this.$emit("change", ques);
    },
    async submitCorrection() {
      if (this.correction.type === "") {
        this.$info("请选择纠错类型");
        return;
      }
      if (this.correction.error_msg === "") {
        this.$info("请输入纠错内容");
        return;
      }
      await this.$http.post("/api/app/myExam/correction", {
        ques_id: this.ques.id,
        type: this.correction.type,
        error_msg: this.correction.error_msg
      });
      this.showCorrection = false;
      this.$success("提交成功");
    },
    async collect() {
      if (this.ques.collect_id > 0) {
        await this.$http.put(
          "/api/app/collect/cancel/" + this.ques.collect_id + "/3"
        );
        this.ques.collect_id = null;
        this.$success("取消收藏成功");
      } else {
        this.ques.collect_id = await this.$http.post("/api/app/collect", {
          ques_id: this.ques.id,
          type: 3
        });
        this.$success("收藏成功");
      }
    },
    onClick(event) {
      let target = event.target;
      if (target.tagName.toLowerCase() == "img") {
        this.images = [target.src];
        this.showImageViewer = true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/varibles.scss";
.question {
  padding: 28px 30px;
  border-bottom: 1px solid #e9ecec;
  position: relative;
  &:last-child {
    border-bottom: none;
  }
  .option {
    font-size: 16px;
    color: #333333;
    font-weight: 400;
    display: flex;
    .rich-text{
       /deep/ p{
        word-break: break-all;
        white-space:pre-wrap;
      }
    }
  }
  .icon-result {
    position: absolute;
    left: 0;
    top: 100px;
    color: white;
    width: 32px;
    height: 32px;
    border-top-right-radius: 50%;
    border-bottom-right-radius: 50%;
    font-size: 20px;
    text-align: center;
    line-height: 32px;
  }
  .icon-right {
    background-color: #30c596;
  }
  .icon-error {
    background-color: #ff5400;
  }
  .stem {
    display: flex;
    font-size: 18px;
    color: #333333;
    margin-bottom: 50px;
    font-family: PingFang SC;
    &.stem5 {
      margin-bottom: 20px;
    }
    .num-type {
      white-space: nowrap;
    }
    .type {
      color: $primary-color;
    }
    .rich-text {
      margin-left: 5px;
      p{
        word-break: break-all;
      }
    }
  }
  .rich-text.stem5 {
    margin-bottom: 40px;
  }
  /deep/ .ivu-radio-group {
    display: flex;
    flex-direction: column;
    .ivu-radio-wrapper {
      display: flex;
      margin-bottom: 30px;
      .option {
        line-height: 1;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  /deep/ .ivu-checkbox-group {
    display: flex;
    flex-direction: column;
    .ivu-checkbox-wrapper {
      display: flex;
      margin-bottom: 30px;
      .option {
        line-height: 1;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .line {
    display: flex;
    .line-title {
      font-size: 18px;
      font-weight: 500;
      margin-bottom: 20px;
    }
    .answer {
      display: flex;
      align-items: center;
      > span:first-child {
        margin-right: 24px;
      }
    }
    .option {
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 10px;
      padding: 20px;
      font-size: 16px;
      margin-bottom: 15px;
      display: block;
      .stem {
        display: flex;
        font-size: 16px;
        align-items: center;
        span:first-child {
          margin-right: 15px;
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
    /deep/ .ivu-radio-group {
      display: block;
      .ivu-radio-wrapper {
        display: inline-block;
        margin-bottom: 0;
      }
    }
    .right {
      margin-left: 15px;
      .option {
        display: flex;
        .num {
          border: 1px solid $primary-color;
          color: $primary-color;
          border-radius: 5px;
          margin-right: 10px;
          width: 78px;
          box-sizing: border-box;
          height: 35px;
          text-align: center;
          line-height: 35px;
          flex: 0 0 auto;
        }
        > div:last-child {
          flex-grow: 1;
        }
      }
    }
    > div {
      flex-grow: 1;
    }
  }
  .analysis {
    padding-top: 60px;
    .collapse {
      border: 1px solid $primary-color;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: $primary-color;
      width: 121px;
      height: 29px;
      display: inline-block;
      text-align: center;
      line-height: 29px;
      margin-bottom: 20px;
      cursor: pointer;
    }
    .answer {
      background-color: #f7f7f7;
      padding: 16px 30px;
      color: #666666;
      .user {
        margin-left: 64px;
      }
    }
    &.analysis5 {
      padding-top: 0;
      .detail {
        padding-left: 0;
      }
    }
    .detail {
      padding: 24px 30px 10px 30px;
      font-size: 16px;
      > div:first-child {
        margin-bottom: 24px;
      }
      label {
        color: #666666;
        margin-right: 12px;
      }
      .point {
        background-color: $primary-color;
        color: white;
        border-radius: 4px;
        padding: 2px 16px;
        margin-right: 10px;
      }
      .analysis-detail {
        display: flex;
        > label {
          white-space: nowrap;
        }
      }
    }
  }
  .operate {
    font-size: 16px;
    color: #595959;
    > div {
      display: flex;
      align-items: center;
      cursor: pointer;
      img {
        margin-right: 5px;
      }
    }
    .f-left {
      margin-right: 40px;
    }
  }
}
.form-item {
  &:first-child {
    align-items: center;
  }
  /deep/ .el-radio-group {
    display: block;
    .el-radio {
      display: inline-block;
      margin-bottom: 0;
    }
  }
}
.subjective-answer {
  display: flex;
  color: #666666;
}
</style>
